import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { useTheme, createUseStyles } from 'react-jss';
import { Container, Button } from '@sm/wds-react';
import { Typography } from '@wds/typography';
import { generateMetricsAttribute } from '@sm/metrics';
import { createURL } from '@sm/utils';

import researchSVG from '../../../../static/images/logo-research.svg';

const COPY = defineMessages({
  THANK_YOU: {
    id: 'SurveyThanks.Research.ThankYou',
    defaultMessage: 'Thank you for taking the survey.',
    description:
      '[Type: Header][vis: high] - The only message on the webpage. Used on a Nonbranded webpage to say thank you to survey respondents and signal the end of the survey.',
  },

  POWERED_BY: {
    id: 'SurveyThanks.Research.PoweredBy',
    defaultMessage: 'powered by',
    description:
      '[Type: Label][Vis: med] - This figure of speech is used to introduce and display the SurveyMonkey Logo',
  },
  EMBEDDED_CTA: {
    id: 'SurveyThanks.Research.EmbeddedCTA',
    defaultMessage: 'Learn More',
    description:
      '[Type: Label][Vis: med] - This is the phrase used inside a button that directs views to a signup page',
  },
});

const useStyles = createUseStyles(theme => {
  return {
    container: {
      height: theme.util.fullHeight,
    },
    researchLogo: {
      height: 40,
      width: 200,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundImage: `url(${researchSVG})`,
    },
  };
});

const Research = () => {
  const theme = useTheme();
  const classes = useStyles({ theme });

  const utSource = 'survey_thanks';
  const utSource2 = 'research';

  return (
    <Container className={classes.container} flex flexAlign="center" flexJustify="center" flexDirection="column">
      <Typography color="dark" component="div" pb={3} variant="cardTitle">
        {t(COPY.THANK_YOU)}
      </Typography>
      <Typography color="darkMuted" component="div" p={2} variant="body">
        {t(COPY.POWERED_BY)}
      </Typography>
      <Container className={classes.researchLogo} m={1} />
      <Button
        color="muted"
        size="sm"
        href={createURL('/user/sign-up/', {
          ut_source: utSource,
          ut_source2: utSource2,
        })}
        data-sm-metric={generateMetricsAttribute({
          data: {
            actionType: `${utSource}_click_${utSource2}_cta_to_sign_up`,
            actionFlow: { utSource },
          },
        })}
      >
        {t(COPY.EMBEDDED_CTA)}
      </Button>
    </Container>
  );
};

export default Research;
